
import React from "react"
import { useNavigate } from 'react-router-dom'
import CountrieSelection from '../customNodes/CountriesSelection';
import { useState } from 'react';
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import {
    getserverurl, getvariabletable
} from "../dbconnector/connector";

const General = (props) => {
    const t = props.translation
    const [general, setGeneral] = useState([]);
    const [contract, setContract] = useState({ value: '' })
    const [isDisabled, setIsDisabled] = useState(true);



    //dop something after loading page
    useEffect(() => {
        LoadGeneral();
    }, []);

    const LoadGeneral = () => {
        setIsDisabled(true);
        setGeneral([]);
        getvariabletable("general").then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setGeneral(body[0])
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
       
    }

    const handleEdit = () => {
        setIsDisabled(false);
    }

    const handleitemchange = (e) => {
        setGeneral((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })
    }
    const openContract = () => {
        window.open(getserverurl() + general.arbeidsregelement, "_blank")
    }
    const handleCancel = () => {
        //window.location.reload();
        LoadGeneral();
    }
    const onSubmit = (e) => {
        e.preventDefault();

        // if (contract.value.name) {
        //     updateHotelData({ ...toUpdate, Contract: contract }, hotel.Hotel_ID).then(() => {
        //         //////console.log("/hotels/" + hotel.Hotel_ID)
        //         window.location.reload();
        //     })
        // } else {
        //     updateHotelData({ ...toUpdate }, hotel.Hotel_ID).then(() => {
        //         //////console.log('/hotels/' + hotel.Hotel_ID)
        //         window.location.reload();
        //     })

        // }

    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="content">
                    <form className="form" onSubmit={onSubmit} autocomplete="off">
                        <div className='formCollapse'>
                            <label className='formtitle'>
                                {t('Details')} : {general.naam}
                            </label>
                        </div>
                        <div id="formcontent">
                            <div className="formchild">
                                <label className='labelhotel'>
                                    {t('Name')}:
                                </label>
                                <input id="hotelnaam" name="naam" value={general.naam} required className="normalinput" disabled={isDisabled} onChange={handleitemchange}></input>
                                <p></p><p></p>
                                <label className='labelhotel'>
                                    {t('BTWnr')}:
                                </label>
                                <input id="btw" className="normalinput" required type='text' name="btw_nummer" value={general.btw_nummer} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('Phone')}:
                                </label>
                                <input id="Phone" type='text' required className="normalinput" name="gemeente" value={general.telefoon} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('Street')}:
                                </label>
                                <input id="straatnaam" type='text' required className="normalinput" name="straatnaam" value={general.straatnaam} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('Nr')}:
                                </label>
                                <input id="huisnummer" type='number' required className="normalinput" name="huisnummer" value={general.huisnummer} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('Postbus')}:
                                </label>
                                <input id="bus" type='text' className="normalinput" name="postbus" value={general.postbus} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('ZipCode')}:
                                </label>
                                <input id="zipcode" type='number' required className="normalinput" name="postcode" value={general.postcode} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('Community')}:
                                </label>
                                <input id="gemeente" type='text' required className="normalinput" name="gemeente" value={general.gemeente} disabled={isDisabled} onChange={handleitemchange}></input>
                                <label className='labelhotel'>
                                    {t('Country')}:
                                </label>
                                <CountrieSelection isDisabled={isDisabled} data={{ land: general.land, handleitemchange: handleitemchange }} cssClass="countrySelection" t={t} />
                            </div>
{/* 
                            <div id="editDiv" className="formchildButton" style={isDisabled === false ? { display: "none" } : { display: "grid" }}>
                                <Button id="editButton" className='' onClick={handleEdit}>{t('Edit')}</Button>
                            </div>
                            <div id="saveDiv" className="two_Buttons" style={isDisabled === true ? { display: "none" } : { display: "grid" }}>
                                <Button id="saveButton" type="submit" className='Savebutton'>{t('Save')}</Button>
                                <Button id="cancelButton" className='Savebutton' onClick={handleCancel}>{t('Cancel')}</Button>
                            </div> */}
                        </div>
                    </form>
                </div>

            </div>
        </>
    )

}

export default General